const LOAD_DETAIL_FIELD_OF_STUDY           = 'LOAD_DETAIL_FIELD_OF_STUDY'
const LOAD_DETAIL_FIELD_OF_STUDY_SUCCESS   = 'LOAD_DETAIL_FIELD_OF_STUDY_SUCCESS'
const LOAD_DETAIL_FIELD_OF_STUDY_FAILED    = 'LOAD_DETAIL_FIELD_OF_STUDY_FAILED'
const UNMOUNT_DETAIL_FIELD_OF_STUDY        = 'UNMOUNT_DETAIL_FIELD_OF_STUDY'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const fieldOfStudyDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_FIELD_OF_STUDY:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_FIELD_OF_STUDY_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_FIELD_OF_STUDY_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_FIELD_OF_STUDY:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default fieldOfStudyDetailReducer;